<app-shell-admin-warning-banner></app-shell-admin-warning-banner>
<ng-container *ngIf="viewModel$ | async as viewModel">
	<dx-data-grid height="calc(100vh - 320px)"
		[dataSource]="viewModel.dataSource"
		[showBorders]="true"
		(onRowRemoving)="rowRemoving($event, viewModel)"
		(onEditorPreparing)="onEditorPreparing($event)"
	>
		<dxo-sorting mode="multiple"></dxo-sorting>
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-editing mode="row" [allowAdding]="canManageUserCompanies" [allowUpdating]="canManageUserCompanies" [allowDeleting]="canManageUserCompanies"></dxo-editing>
		<dxo-search-panel [visible]="true"></dxo-search-panel>

		<dxi-column
			dataField="companyId"
			caption="Company"
		>
			<dxo-lookup
				[dataSource]="viewModel.companyDatasource"
				valueExpr="id"
				displayExpr="name"
			>
			</dxo-lookup>
		</dxi-column>
		<dxi-column
			dataField="userId"
			caption="User"
		>
			<dxo-lookup
				[dataSource]="viewModel.userDatasource"
				valueExpr="id"
				displayExpr="name"
			>
			</dxo-lookup>
		</dxi-column>
		<dxi-column
			dataField="isOwner"
			caption="Is owner"
			dataType="boolean"
			[width]="80"
		>
		</dxi-column>
	</dx-data-grid>
</ng-container>
